import React, { FunctionComponent, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  changeRefCountersRoutine,
  disableRefCounterRoutine,
  setDisabledRefTypesRoutine,
  setRefReqReferencesRoutine,
  toggleAdvancedReqRoutine
} from '../../routines';
import { IAppState } from '../../../../common/models/store/IAppState';
import { IRefReqCounters } from '../../../../common/models/referenceRequest/IRefReqCounters';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { ReferenceType } from '../../../../common/enums/ReferenceType';
import { ILastRefReqCounters } from '../../../../common/models/referenceRequest/ILastRefReqCounters';
import { INewContactInfo } from '../../../../common/models/contact/INewContactInfo';
import { getCountersSum } from '../../../../common/helpers/refCountersHelper';
import RefReqCounters from '../../../../components/RefReqCounters';

interface IProps {
  refCounters: IRefReqCounters;
  lastCounters: ILastRefReqCounters | null;
  disabledTypes: ReferenceType[];
  isAdvanced: boolean;
  isAddReferencesEnabled: boolean;
  defaultCounters: IRefReqCounters;
  changeCounters: IBindingCallback1<IRefReqCounters>;
  disableCounter: IBindingCallback1<ReferenceType>;
  setDisabledRefTypes: IBindingCallback1<ReferenceType[]>;
  toggleAdvancedReq: IBindingCallback1<boolean>;
  addReferences: IBindingCallback1<INewContactInfo[]>;
}

const Step3: FunctionComponent<IProps> = ({
  isAdvanced,
  refCounters,
  lastCounters,
  disabledTypes,
  defaultCounters,
  isAddReferencesEnabled,
  changeCounters,
  disableCounter,
  toggleAdvancedReq,
  setDisabledRefTypes,
  addReferences
}) => {
  const prevCounters = lastCounters?.counters;

  useEffect(() => {
    if (!refCounters.totalCount) {
      const isDefaultAdvanced = prevCounters
        ? Boolean(getCountersSum(prevCounters))
        : Boolean(getCountersSum(defaultCounters));

      changeCounters(prevCounters || defaultCounters);
      setDisabledRefTypes(lastCounters ? lastCounters.disabledTypes : []);
      toggleAdvancedReq(isDefaultAdvanced);
    }
  }, []);

  return (
    <RefReqCounters
      withBackground
      isAdvanced={isAdvanced}
      refCounters={refCounters}
      disabledTypes={disabledTypes}
      isAddReferencesEnabled={isAddReferencesEnabled}
      changeCounters={changeCounters}
      disableCounter={disableCounter}
      toggleAdvancedReq={toggleAdvancedReq}
      enableAddReferences={() => addReferences([])}
    />
  );
};

const mapStateToProps = ({
  requestBuilder: { refCounters, lastCounters, disabledTypes, isAdvancedRequest, candidates },
  workspace: { defaultCounters }
}: IAppState) => ({
  refCounters,
  lastCounters,
  disabledTypes,
  isAdvanced: isAdvancedRequest,
  isAddReferencesEnabled: candidates.length === 1,
  defaultCounters: defaultCounters as IRefReqCounters
});

const mapDispatchToProps = {
  changeCounters: changeRefCountersRoutine,
  disableCounter: disableRefCounterRoutine,
  setDisabledRefTypes: setDisabledRefTypesRoutine,
  toggleAdvancedReq: toggleAdvancedReqRoutine,
  addReferences: setRefReqReferencesRoutine
};

export default connect(mapStateToProps, mapDispatchToProps)(Step3);
